import fetchWithCache from './fetchWithCache';

export const fetchInventory = (modelInfo, config, postalCode) => {
  const {
    language,
    country,
    brand,
    year,
    carline,
    bodyStyle,
    v3ServicesPath,
  } = modelInfo;
  const { styleId, selections } = config;
  const rpos = selections.rpos.join(',');
  const url = `${v3ServicesPath}/inventory/${language}/${country}/${brand}/${carline}/${year}/${bodyStyle}/${styleId}/${postalCode}?rpos=${rpos}`;
  return fetchWithCache(url)
    .then((data) => data)
    .catch((error) => null);
};
